import { render, staticRenderFns } from "./ExpectedOrderIcon.vue?vue&type=template&id=24f8b09d"
import script from "./ExpectedOrderIcon.vue?vue&type=script&lang=js"
export * from "./ExpectedOrderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports